import React from "react";
import {
    Page,
    Text,
    View,
    Document,
    StyleSheet, Image
} from "@react-pdf/renderer";


const styles = StyleSheet.create({
    page: {
        padding: 20,
        fontSize: 9,
    },

    title: {
        textAlign: "center",
        fontSize: 14,
        fontWeight: "bold",
        marginBottom: 15,
    },

    projectName: {
        fontSize: 11,
        fontWeight: "bold",
        marginBottom: 8,
    },

    overheadTitle: {
        fontSize: 10,
        // fontWeight: "bold",
        marginTop: 6,
        marginBottom: 4,
    },

    table: {
        display: "table",
        width: "100%",
        marginBottom: 8,
        borderWidth: 1,
        borderColor: "#000",
        borderStyle: "solid",
    },

    tableRow: {
        flexDirection: "row",
        borderBottomWidth: 1,
        borderColor: "#000",
    },

    headerCell: {
        padding: 4,
        fontWeight: "bold",
        backgroundColor: "#f0f0f0",
        textAlign: "center",
        borderRightWidth: 1,
        borderColor: "#000",

    },

    cell: {
        padding: 4,
        borderRightWidth: 1,
        borderColor: "#000",
    },

    rightCell: {
        padding: 4,
        textAlign: "right",
    },

    footerLine: {
        width: "100%",
        height: 1,
        backgroundColor: "#000",
        marginTop: 10,
        marginBottom: 10,
    },

    projectSummary: {
        flexDirection: "row",
        justifyContent: "space-between",
        width: "100%",
        marginTop: 5,
        fontSize: 10,
        fontWeight: "bold",
    },
    separator: {
        width: "100%",
        height: 1,
        backgroundColor: "#000",
        marginTop: 12,
        marginBottom: 12,
    },
    separator2: {
        width: 1,
        backgroundColor: "#000",
        marginHorizontal: 8,
        fontWeight: "bold"
    },


    //For Header
    /* HEADER */
    headerWrapper: {
        position: "absolute",
        top: 15,
        left: 20,
        right: 20,
        height: 50,
        justifyContent: "center",
        alignItems: "center",
    },
    headerImage: {
        width: "100%",
        height: 50,
        objectFit: "contain",
    },
     footerWrapper: {
        position: "absolute",
        bottom: 0,
        left: 0,
        right: 0,
        height: 50,
    },

    footerImage: {
        width: "100%",
        height: "100%",
    },
});


// Group rows by overhead inside each project
const groupByOverhead = (rows) => {
    const result = {};
    rows.forEach((r) => {
        if (!result[r.Overheads]) result[r.Overheads] = [];
        result[r.Overheads].push(r);
    });
    return result;
};


const OnsitesummaryPDF = ({ data = [], Project = [], filters = {} }) => {
    const selectedProjects = Array.isArray(Project) ? Project : [Project];
    let grandTotalAmount = 0;
    let finalGrandTotal = 0;
    let finalCreditTotal = 0;
    let finalDebitTotal = 0;
    const formatAmount = (value) =>
        Number(value || 0).toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    return (
        <Document>
            <Page size="A4" orientation="landscape" style={styles.page}>
                {/* <View fixed style={styles.headerWrapper}>
                    {filters.HeaderImg && (
                        <Image
                            src={`${filters.Imageurl}/uploads/images/${filters.HeaderImg}`}
                            style={styles.headerImage}
                        />
                    )}
                </View> */}

                <Text style={styles.title}>
                    Onsite Activities - Project based Summary
                </Text>

                {/* {selectedProjects.map((proj, idx) => {
                    const projectRows = data.filter(
                        (r) => r.ProjectName === proj?.Name
                    );

                    const overheadGroups = groupByOverhead(projectRows);

                    const totalTransactions = projectRows.length;
                    const totalAmount = projectRows.reduce(
                        (sum, r) => sum + Number(r.Value || 0),
                        0
                    ); */}

                {selectedProjects.map((proj, idx) => {
                    const projectRows = data.filter(
                        (r) => r.ProjectName === proj?.Name
                    );

                    const overheadGroups = groupByOverhead(projectRows);
                    const allFilteredRows = Object.values(overheadGroups)
                        .flat()
                        .filter(
                            (r) =>
                                r.ChildYorN === "Y" &&
                                Number(r.Quantity || 0) > 0
                        );

                    const totalCreditAmount = allFilteredRows
                        .filter(r => r.AccountType === "Credit")
                        .reduce((sum, r) => sum + Number(r.Value || 0), 0);

                    const totalDebitAmount = allFilteredRows
                        .filter(r => r.AccountType === "Debit")
                        .reduce((sum, r) => sum + Number(r.Value || 0), 0);
                    // const totalTransactions = projectRows.length;
                    // const totalAmount = projectRows.reduce(
                    //     (sum, r) => sum + Number(r.Value || 0),
                    //     0
                    // );
                    // Only valid rows

                    const validProjectRows = projectRows.filter(
                        (r) =>
                            r.ChildYorN === "Y" &&
                            Number(r.Quantity || 0) > 0
                    );
                    //  If no valid rows → skip project completely
                    if (validProjectRows.length === 0) {
                        return null;
                    }

                    // Now calculate totals only from valid rows
                    const totalTransactions = validProjectRows.length;

                    const totalAmount = validProjectRows.reduce(
                        (sum, r) => sum + Number(r.Value || 0),
                        0
                    );
                    finalGrandTotal += totalAmount;
                    finalCreditTotal += totalCreditAmount;
                    finalDebitTotal += totalDebitAmount;

                    // grandTotalAmount += totalAmount;

                    if (totalTransactions === 0 && totalAmount === 0) {
                        return null;
                    }

                    return (
                        <View key={idx} style={{ marginBottom: 10 }}>

                            {/* Project Name */}
                            <Text style={styles.projectName}>
                                Project Name : {proj?.Name}
                            </Text>

                            {/* Each Overhead Section */}
                            {Object.entries(overheadGroups).map(
                                ([overheadName, rows], ohIndex) => {

                                    // const overheadTotal = rows.reduce(
                                    //     (sum, r) => sum + Number(r.Value || 0),
                                    //     0
                                    // );
                                    const filteredRows = rows.filter(
                                        (r) =>
                                            r.ChildYorN === "Y" &&
                                            Number(r.Quantity || 0) > 0
                                    );

                                    if (filteredRows.length === 0) return null;
                                    // if (filteredRows.length === 0) {
                                    //     return (
                                    //         <View>
                                    //             <Text style={{ fontStyle: "italic", textAlign: "center", marginVertical: 5 }}>
                                    //                 No Data Available
                                    //             </Text>
                                    //         </View>
                                    //     );
                                    // }
                                    // const overheadTotal = filteredRows.reduce(
                                    //     (sum, r) => sum + Number(r.Value || 0),
                                    //     0
                                    // );
                                    const overheadCreditTotal = filteredRows
                                        .filter(r => r.AccountType === "Credit")
                                        .reduce((sum, r) => sum + Number(r.Value || 0), 0);

                                    const overheadDebitTotal = filteredRows
                                        .filter(r => r.AccountType === "Debit")
                                        .reduce((sum, r) => sum + Number(r.Value || 0), 0);
                                    return (
                                        <View key={ohIndex}>
                                            <Text style={styles.overheadTitle}>
                                                Overhead Name : {overheadName}
                                            </Text>


                                            <View style={styles.table}>
                                                {/* Header Row */}
                                                <View style={styles.tableRow}>
                                                    <Text style={[styles.headerCell, { flex: 0.5 }]}>SL#</Text>
                                                    <Text style={[styles.headerCell, { flex: 1 }]}>Date</Text>
                                                    <Text style={[styles.headerCell, { flex: 5.5 }]}>Comments</Text>
                                                    {/* <Text
                                                        style={[
                                                            styles.rightCell,
                                                            {
                                                                flex: 1.5,
                                                                fontWeight: "bold",
                                                                backgroundColor: "#f0f0f0",
                                                                textAlign: "center"
                                                            }
                                                        ]}
                                                    >
                                                        Amount
                                                    </Text> */}
                                                    <Text style={[styles.headerCell, { flex: 1.5, textAlign: "center" }]}>
                                                        Credit
                                                    </Text>
                                                    <Text style={[
                                                        styles.rightCell,
                                                        {
                                                            flex: 1.5,
                                                            fontWeight: "bold",
                                                            backgroundColor: "#f0f0f0",
                                                            textAlign: "center"
                                                        }
                                                    ]}>
                                                        Debit
                                                    </Text>
                                                </View>

                                                {/* Rows */}
                                                {/* {rows.map((r, i) => ( */}
                                                {rows
                                                    .filter(
                                                        (r) =>
                                                            r.ChildYorN === "Y" &&
                                                            Number(r.Quantity || 0) > 0
                                                    )
                                                    .map((r, i) => (
                                                        <View key={i} style={styles.tableRow}>
                                                            <Text style={[styles.cell, { flex: 0.5, textAlign: "center" }]}>
                                                                {i + 1}
                                                            </Text>
                                                            <Text style={[styles.cell, { flex: 1, textAlign: "center" }]}>
                                                                {r.Date}
                                                            </Text>
                                                            <Text style={[styles.cell, { flex: 5.5 }]}>{r.Comments}</Text>
                                                            {/* <Text style={[styles.rightCell, { flex: 1.5 }]}>{r.Value}</Text> */}
                                                            {/* Credit Column */}
                                                            <Text style={[styles.cell, { flex: 1.5, textAlign: "right" }]}>
                                                                {r.AccountType === "Credit" ? Number(r.Value).toFixed(2) : "0.00"}
                                                            </Text>

                                                            {/* Debit Column */}
                                                            <Text style={[styles.rightCell, { flex: 1.5 }]}>
                                                                {r.AccountType === "Debit" ? Number(r.Value).toFixed(2) : "0.00"}
                                                            </Text>
                                                        </View>
                                                    ))}

                                                {/* Total Row */}
                                                {/* <View style={styles.tableRow}>
                                                    <Text style={[styles.cell, { flex: 0.5 }]}></Text>
                                                    <Text style={[styles.cell, { flex: 1 }]}></Text>
                                                    <Text style={[styles.cell, { flex: 7.5, fontWeight: "bold", textAlign: "right" }]}>
                                                        Total
                                                    </Text>
                                                    <Text style={[styles.rightCell, { flex: 1.5, fontWeight: "bold" }]}>
                                                        {overheadTotal.toFixed(2)}
                                                    </Text>
                                                </View> */}
                                                {/* Total Row */}
                                                <View style={styles.tableRow}>
                                                    <Text style={[styles.cell, { flex: 0.5 }]}></Text>
                                                    <Text style={[styles.cell, { flex: 1 }]}></Text>
                                                    <Text
                                                        style={[
                                                            styles.cell,
                                                            { flex: 5.5, fontWeight: "bold", textAlign: "right" }
                                                        ]}
                                                    >
                                                        Total
                                                    </Text>

                                                    {/* Credit Total */}
                                                    <Text style={[styles.cell, { flex: 1.5, textAlign: "right", fontWeight: "bold" }]}>
                                                        {formatAmount(overheadCreditTotal)}
                                                    </Text>

                                                    {/* Debit Total */}
                                                    <Text style={[styles.rightCell, { flex: 1.5, textAlign: "right", fontWeight: "bold" }]}>
                                                        {formatAmount(overheadDebitTotal)}
                                                    </Text>
                                                </View>
                                            </View>

                                        </View>
                                    );
                                }
                            )}

                            {/* Project Summary Footer */}
                            <View style={styles.projectSummary}>
                                <Text>Project Name : {proj?.Name}</Text>
                                {/* <View style={styles.separator2} /> */}
                                <Text>Transaction Count : {formatAmount(totalTransactions)}</Text>
                                {/* <View style={styles.separator2} /> */}
                                <Text>Total Amount : {formatAmount(totalAmount)}</Text>
                            </View>
                            <View style={styles.separator} />
                            {/* Final Grand Total */}
                            {/* <View style={{ marginTop: 10 }}>
                                <Text style={{ fontWeight: "bold" }}>
                                    Grand Total Amount : {grandTotalAmount.toFixed(2)}
                                </Text>
                            </View> */}
                            {/* <View style={styles.projectSummary}>
                                <Text>Grand Total Amount : {grandTotalAmount.toFixed(2)}</Text>
                                <Text>Credit Amount : </Text>
                                <Text>Debit Amount : </Text>
                            </View> */}
                        </View>
                    );
                })}
                <View style={{ marginTop: 15 }}>
                    <View style={styles.projectSummary}>
                        {/* <Text style={{ fontWeight: "bold" }}>
                            Grand Total Amount : {finalGrandTotal.toFixed(2)}
                        </Text> */}
                        <Text style={{ fontWeight: "bold" }}>
                            Total Credit Amount : {formatAmount(finalCreditTotal)}
                        </Text>
                        <Text style={{ fontWeight: "bold" }}>
                            Total Debit Amount : {formatAmount(finalDebitTotal)}
                        </Text>
                    </View>
                </View>
                <View style={styles.separator} />
                {/* <View fixed style={styles.footerWrapper}>
                    {filters.FooterImg && (
                        <Image
                            src={`${filters.Imageurl}/uploads/images/${filters.FooterImg}`}
                            style={styles.footerImage}
                        />
                    )}
                </View> */}
            </Page>
        </Document>
    );
};

export default OnsitesummaryPDF;
